import { PlanConstant } from '@utility/constants/pricing';
import type { NavigateFunction } from 'react-router';
import type { ISubscription } from 'types/auth/types';

export const redirectFunction = (
  redirectUrl: string | null,
  subscription: ISubscription | null,
  navigate: NavigateFunction,
) => {
  const isTactical = subscription?.name === PlanConstant['3PL'];

  if (redirectUrl) {
    navigate(encodeURI(redirectUrl));
  } else if (isTactical) {
    navigate('/app/catalogs/catalog/');
  } else {
    navigate('/app/dashboard/awaiting-actions');
  }
};

/**
 * "Public view" was the read-only shipment view the WMS-partner login
 * (`/wms/login`) produced. That login's API route is gone and EN-3163 deleted
 * the pages, so no session is a public viewer any more.
 *
 * This must never be derived from `firebase_auth_token`. EN-3480 removes that
 * field from every login response, and a session from the normal login is
 * never a public viewer. If a partner flow ever returns, key this on an
 * explicit marker that only that flow writes into the stored session.
 */
export const isPublicView = (): boolean => false;

/**
 * Whether the batch, label and notification calls stay off for this session.
 * Kept outside the auth context so the rule can be unit-tested.
 */
export const blocksAdditionalCalls = (
  pathname: string,
  user: { organization_id?: string | null } | null | undefined,
): boolean => isPublicView() || !user?.organization_id;
